export default __webpack_public_path__ + "static/media/icon-cloud-upload.5fd11956.svg";